@if (showSpinner) {
  <c-spinner />
}

<router-outlet />

<p-toast />
